export const isFullScreen =
  (window.navigator as any).standalone ||
  (typeof window.matchMedia === 'function'
    ? window.matchMedia('(display-mode: standalone)').matches
    : false);
